import { IOperatorPromo, Maybe } from 'src/types/graphql'

interface OperatorPromoNoteProps {
  promo: Maybe<IOperatorPromo> | undefined
  className?: string
  /** One truncated line — for the mobile sticky price bar. */
  compact?: boolean
}

/**
 * «Promoción del operador» block for the listing price card. Always labeled as
 * the OPERATOR's promotion — SpotMe bills nothing on Traditional and never
 * calls this its own discount (four-vertex rule; counsel queue #40). The
 * server already hid it unless it was re-verified on the operator's site
 * within 45 days.
 */
const OperatorPromoNote = ({
  promo,
  className = '',
  compact = false
}: OperatorPromoNoteProps) => {
  if (!promo) return null
  if (compact) {
    return (
      // Two lines, not `truncate`: at 320px the single line cut the offer
      // itself («Hasta 20% de descu…») — the one part a renter needs.
      <p
        className={`line-clamp-2 text-[11px] leading-snug text-ink-700 ${className}`}
      >
        <span className="font-display text-[10px] tracking-[0.14em] text-promo-700 uppercase">
          Promoción del operador
        </span>
        {` · ${promo.headline}`}
      </p>
    )
  }
  return (
    <aside
      aria-label="Promoción del operador"
      className={`rounded-lg border border-promo-600/25 bg-promo-100 px-3 py-2 ${className}`}
    >
      {/* Same «rosa mexicano» as every promo badge (PromoBadge) — still
          labelled as the OPERATOR's offer, never SpotMe's. */}
      <span className="flex items-center gap-1 font-display text-[10px] tracking-[0.16em] text-promo-700 uppercase md:text-[11px]">
        <i aria-hidden className="si si-discount text-[11px] tracking-normal" />
        Promoción del operador
      </span>
      <p className="text-[13px] leading-snug font-medium text-ink-700 md:text-[14px]">
        {promo.headline}
      </p>
      {promo.conditions && (
        <p className="mt-0.5 text-[12px] leading-snug text-grey-700">
          {promo.conditions}
        </p>
      )}
    </aside>
  )
}

export default OperatorPromoNote
